
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Phone, Calendar, Users, CheckCircle2 } from "lucide-react";

const ProcessSection = () => {
  const steps = [
    {
      icon: Phone,
      title: "Get Free Estimate",
      description: "Contact us by phone or online form for a personalized quote tailored to your specific cleaning needs.",
      step: "01"
    },
    {
      icon: Calendar,
      title: "Schedule Service",
      description: "Choose a convenient time that fits your routine. We offer flexible scheduling with automatic reminders.",
      step: "02"
    },
    {
      icon: Users,
      title: "Professional Team Arrives",
      description: "Our trained, insured team arrives on time with all professional equipment and eco-friendly supplies.",
      step: "03"
    },
    {
      icon: CheckCircle2,
      title: "Quality Assurance",
      description: "We perform a thorough walkthrough to ensure every detail meets our high standards and your satisfaction.",
      step: "04"
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Our Simple <span className="bg-gradient-to-r from-brand-gold-dark to-brand-gold-light bg-clip-text text-transparent">4-Step Process</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Getting professional cleaning service has never been easier. 
            Here's how we make it happen for you.
          </p>
        </div>

        {/* Process Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <Card key={index} className="relative text-center group hover:shadow-lg transition-all duration-300 border-border">
                {/* Step Number */}
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-accent text-accent-foreground w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm">
                  {step.step}
                </div>
                
                <CardHeader className="pt-8">
                  <div className="mx-auto mb-4 p-3 bg-secondary rounded-full w-fit group-hover:bg-accent group-hover:text-accent-foreground transition-colors duration-300">
                    <IconComponent className="h-8 w-8" />
                  </div>
                  <CardTitle className="text-foreground">{step.title}</CardTitle>
                </CardHeader>
                
                <CardContent>
                  <p className="text-muted-foreground">{step.description}</p>
                </CardContent>

                {/* Connector Line (hidden on last item) */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 w-4 h-0.5 bg-border"></div>
                )}
              </Card>
            );
          })}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <p className="text-lg text-muted-foreground mb-6">
            Ready to get started? Let's begin with your free, no-obligation estimate.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <div className="flex items-center justify-center space-x-2 text-sm text-muted-foreground">
              <div className="w-2 h-2 bg-accent rounded-full"></div>
              <span>No contracts required</span>
            </div>
            <div className="flex items-center justify-center space-x-2 text-sm text-muted-foreground">
              <div className="w-2 h-2 bg-accent rounded-full"></div>
              <span>Same day estimates available</span>
            </div>
            <div className="flex items-center justify-center space-x-2 text-sm text-muted-foreground">
              <div className="w-2 h-2 bg-accent rounded-full"></div>
              <span>100% satisfaction guaranteed</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
